module.exports = __webpack_public_path__ + "media/images/sp/special_plans/text_day1-f3259fc873369bccadb500006abe2774.svg";